module.exports = __webpack_public_path__ + "img/dimsum-4.5ebcb582.jpg";